"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var date = _ref.date,
    from = _ref.from,
    _ref$onlyDays = _ref.onlyDays,
    onlyDays = _ref$onlyDays === void 0 ? false : _ref$onlyDays;
  return /*#__PURE__*/_react["default"].createElement("span", null, date ? (0, _momentTimezone["default"])(date).tz('Europe/London').from(from || (0, _momentTimezone["default"])(), onlyDays) : '');
};